import { post } from './api'

import type { LoginByEmailTokenResponse } from './types/mfa'

export const postMFAAuth = async (token: string) =>
  post<LoginByEmailTokenResponse>(
    `${process.env.API_BASE_URL}/admin/auth/confirm-login-by-email-token`,
    {
      token,
    }
  )
